export default "__VITE_ASSET__BThij7n$__"